module.exports = __webpack_public_path__ + "img/news6-5.001ccac0.png";